'use client';

import { UIMarket } from '@velocity-exchange/common';
import MarketIcon from 'src/components/Utils/MarketIcon';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { BalanceRowData } from './types';
import { PRESETS, legacyTrim } from 'src/utils/formatNumber/presets';

interface BalanceCellProps {
	row: BalanceRowData;
}

export function BalanceCell({ row }: BalanceCellProps) {
	const { spotMarketIndex, netBase, netQuote } = row;
	const uiMarket = UIMarket.createSpotMarket(spotMarketIndex);

	return (
		<div className="flex flex-col gap-y-xs">
			<div className="flex items-center gap-x-xs">
				<MarketIcon
					marketSymbol={uiMarket.uiSymbols.marketDisplaySymbol}
					className="size-lg"
				/>
				<NumberDisplay
					className="text-text-default"
					value={netBase}
					options={legacyTrim(PRESETS.tradePrecisionLegacy, netBase)}
					isAccountValueToHide
				/>
			</div>
			<div className="typo-body-xs">
				<NumberDisplay
					value={netQuote}
					options={PRESETS.usd}
					isAccountValueToHide
				/>
			</div>
		</div>
	);
}
